const API = 'MediaUploads';

export const API_MEDIA_UPLOADS = {
    UPLOAD_PDF: `${API}/UploadPDFToCloud`
};

export type ValidateOptions = {
    size: number
}